import React from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import getTheme from '../theme/theme';
import { ThemeProvider } from '@mui/material/styles';
import {Button, Box, Container, Typography, Grid } from '@mui/material';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { BASEURL } from "../constants/Common"

interface ResetPasswordParams {
  token: string;
  uidb64: string;
  username:string;
  [key: string]: string; // Add index signature
}

const ConfirmRegistration = (): JSX.Element => {
  const navigate = useNavigate();
  const params = useParams<ResetPasswordParams>();
  const { token, uidb64,username } = params;

  const handleSubmit = async () => {
    try {
      const response = await axios.get<{ detail: string }>(
        //`http://localhost:8000/confirm/${uidb64}/${token}/${username}/`,
        BASEURL + `/confirm/${uidb64}/${token}/${username}/`,
        // Add any data you need to send with the request
      );
      toast.success("Registration confirmation successful");
      navigate('/login');
    } catch (error) {
      toast.error('Failed to confirm registration. Please try again.');
    }
  };

  const handleCancel = () => {
    // Optionally, you can add a confirmation dialog before canceling
    // This function will navigate back to the previous page
    navigate(-1);
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <Container maxWidth='sm'>
        <Box
          sx={{
            marginTop: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography variant="body1">
          Welcome {username}. Please click the confirm button to complete your registration.
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Grid container spacing={2} justifyContent="center">
              <Grid item>
                <Button variant='contained' onClick={handleSubmit}>
                  Confirm
                </Button>
              </Grid>
              <Grid item>
                <Button variant='contained' onClick={handleCancel}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default ConfirmRegistration;
